const ENTRY_SELECTOR = '[data-library-subscription-entry]';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
const DESKTOP_QUERY = '(min-width: 880px)';
const ENTRY_EASING = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

const MOBILE_TRANSITIONS = {
  word: {
    delay: 0,
    duration: 640,
    keyframes: [
      { opacity: 0, transform: 'translateY(20%)', filter: 'blur(8px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  support: {
    delay: 180,
    duration: 620,
    keyframes: [
      { opacity: 0, transform: 'translateY(12px)', filter: 'blur(6px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  actions: {
    delay: 300,
    duration: 600,
    keyframes: [
      { opacity: 0, transform: 'translateY(10px)', filter: 'blur(4px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  visual: {
    delay: 380,
    duration: 700,
    keyframes: [
      { opacity: 0, transform: 'translate3d(0, 16px, 0) scale(0.985)' },
      { opacity: 1, transform: 'none' },
    ],
  },
  panel: {
    delay: 420,
    duration: 680,
    keyframes: [
      { opacity: 0, transform: 'translate3d(0, 14px, 0) scale(0.99)' },
      { opacity: 1, transform: 'none' },
    ],
  },
};

const DESKTOP_TRANSITIONS = {
  word: {
    delay: 0,
    duration: 600,
    keyframes: [
      { opacity: 0, transform: 'translateY(18%)', filter: 'blur(7px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  support: {
    delay: 160,
    duration: 600,
    keyframes: [
      { opacity: 0, transform: 'translateY(12px)', filter: 'blur(5px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  actions: {
    delay: 280,
    duration: 580,
    keyframes: [
      { opacity: 0, transform: 'translateY(10px)', filter: 'blur(4px)' },
      { opacity: 1, transform: 'none', filter: 'none' },
    ],
  },
  visual: {
    delay: 320,
    duration: 680,
    keyframes: [
      { opacity: 0, transform: 'translate3d(0, 18px, 0) scale(0.988)' },
      { opacity: 1, transform: 'none' },
    ],
  },
  panel: {
    delay: 400,
    duration: 660,
    keyframes: [
      { opacity: 0, transform: 'translate3d(0, 16px, 0) scale(0.992)' },
      { opacity: 1, transform: 'none' },
    ],
  },
};

const root = document.documentElement;
const subscription = document.querySelector('[data-library-subscription-entry-root]');
const reducedMotion = window.matchMedia(REDUCED_MOTION_QUERY);

const completeWithoutMotion = () => {
  root.dataset.librarySubscriptionEntryState = 'complete';
  root.removeAttribute('data-library-subscription-entry-arrival');
};

const isInitiallyVisible = (element, viewportHeight, headerBottom) => {
  const bounds = element.getBoundingClientRect();

  return (
    bounds.width > 0 &&
    bounds.height > 0 &&
    bounds.right > 0 &&
    bounds.left < window.innerWidth &&
    bounds.bottom > headerBottom &&
    bounds.top < viewportHeight
  );
};

const startSubscriptionEntry = () => {
  if (
    !subscription ||
    reducedMotion.matches ||
    typeof Element.prototype.animate !== 'function' ||
    root.dataset.librarySubscriptionEntryStarted === 'true'
  ) {
    completeWithoutMotion();
    return;
  }

  root.dataset.librarySubscriptionEntryStarted = 'true';

  const viewportHeight = window.innerHeight;
  const header = document.querySelector('.site-header');
  const headerBottom = header instanceof HTMLElement
    ? Math.max(0, header.getBoundingClientRect().bottom)
    : 0;
  const candidates = Array.from(subscription.querySelectorAll(ENTRY_SELECTOR));
  const transitions = window.matchMedia(DESKTOP_QUERY).matches
    ? DESKTOP_TRANSITIONS
    : MOBILE_TRANSITIONS;
  const wordCandidates = candidates.filter(
    (element) => element.dataset.librarySubscriptionEntry === 'word',
  );
  const animations = [];

  candidates.forEach((element) => {
    if (!isInitiallyVisible(element, viewportHeight, headerBottom)) {
      return;
    }

    const transition = transitions[element.dataset.librarySubscriptionEntry];

    if (!transition) {
      return;
    }

    const wordIndex = transition === transitions.word ? wordCandidates.indexOf(element) : 0;
    const delay = transition.delay + Math.max(0, wordIndex) * (transitions === DESKTOP_TRANSITIONS ? 24 : 34);

    element.classList.add('is-library-subscription-entry-active');
    animations.push(
      element.animate(transition.keyframes, {
        delay,
        duration: transition.duration,
        easing: ENTRY_EASING,
        fill: 'both',
      }),
    );
  });

  root.dataset.librarySubscriptionEntryState = 'running';

  if (animations.length === 0) {
    completeWithoutMotion();
    return;
  }

  Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
    completeWithoutMotion();
    animations.forEach((animation) => animation.cancel());
    candidates.forEach((element) =>
      element.classList.remove('is-library-subscription-entry-active'),
    );
  });
};

window.requestAnimationFrame(startSubscriptionEntry);
